import React, { useState, useEffect, useRef } from "react";
import { Transaction_SystemMessage } from "../../Connections/Transaction";
import moment from "jalali-moment";

import "../../Styles/ComponentBell.css";

const ComponentBellReceive = ({
  id,
  icon,
  day,
  time,
  text,
  image,
  hashtags,
  postType,
  type,
  comment,
  fullDate,
  postUser,
  audioId,
  setAudioId,
}) => {
  // ========================  handle audio player  =========================
  const refAudio = useRef(null);
  const [iconPlayer, setIconPlayer] = useState(true);
  const [volumePlayer, setVolumePlayer] = useState(true);
  const [timePlayer, setTimePlayer] = useState();
  const song = useRef(null);
  const song2 = useRef(null);

  const line = useRef(null);
  const line2 = useRef(null);

  useEffect(() => {
    if (id !== audioId) {
      refAudio?.current?.pause();
      setIconPlayer(true);
    }
  }, [audioId]);

  const playPause = () => {
    setAudioId(id);
    if (refAudio.current.paused) {
      refAudio.current?.play();
      setIconPlayer(false);
    } else {
      refAudio?.current?.pause();
      setIconPlayer(true);
    }
  };

  const changeVolume = () => {
    if (refAudio.current.volume == 1) {
      refAudio.current.volume = 0;
      setVolumePlayer(false);
    } else {
      refAudio.current.volume = 1;
      setVolumePlayer(true);
    }
  };

  // var pppOfSong = refAudio?.current?.currentTime / refAudio?.current?.duration;
  // console.log(song.current.offsetWidth * pppOfSong);

  // console.log(pppOfSong);
  // console.log(line);

  var lineWidth = "";
  // console.log(song);

  const updateTime = () => {
    var currentSeconds =
      (Math.floor(refAudio.current.currentTime % 60) < 10 ? "0" : "") +
      Math.floor(refAudio.current.currentTime % 60);
    var currentMinutes = Math.floor(refAudio.current.currentTime / 60);
    setTimePlayer(
      Math.floor(refAudio.current.duration / 60) +
        ":" +
        (Math.floor(refAudio.current.duration % 60) < 10 ? "0" : "") +
        Math.floor(refAudio.current.duration % 60) +
        " / " +
        currentMinutes +
        ":" +
        currentSeconds
    );
    var percentageOfSong =
      refAudio?.current?.currentTime / refAudio?.current?.duration;

    var percentageOfSlider = song?.current?.offsetWidth * percentageOfSong;
    var percentageOfSlider2 = song2?.current?.offsetWidth * percentageOfSong;

    line.current.style.width = Math.round(percentageOfSlider) + "px";
    line2.current.style.width = Math.round(percentageOfSlider2) + "px";
  };

  const setLocation = (percentage) => {
    refAudio.current.currentTime = refAudio.current.duration * percentage;
  };

  const setSongPosition = (e) => {
    var songSliderWidth = e.target.offsetWidth;
    var evtobj = window.event ? window.event : e;
    let clickLocation = evtobj.layerX - e.target.offsetLeft;
    var percentage = clickLocation / songSliderWidth;
    setLocation(percentage);
  };

  const next = () => {
    refAudio.current.currentTime += 5;
  };

  const pre = () => {
    refAudio.current.currentTime -= 5;
  };

  return (
    <div key={id}>
      {postType === "Picture" && (
        <div className="BellNotification_content-inside">
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="top"
          >
            {type === "لایک" ? (
              <img className="send-img" src={icon} />
            ) : (
              <img className="send-img" src="/imgs/BellNotif/comment.svg" />
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginLeft: "6px" }}
                  src="/imgs/BellNotif/imgProfile.svg"
                />
                <p className="center-title">
                  {type === "لایک" ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "bold",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        {postUser}
                      </p>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        لایکت کرده:
                      </p>
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "bold",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        {postUser}
                      </p>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        کامنت گذاشته:
                      </p>
                    </div>
                  )}
                </p>
              </div>
              <p className="top-time number-font">
                {moment(fullDate).locale("fa").format("YYYY/m/DD")}
              </p>
            </div>
          </div>
          <div className="podcast">
            <div style={{ marginTop: "15px" }}>
              <div className="podcast-text">{comment}</div>
              <div className="test-karshenasi-mob">{comment}</div>
            </div>
            <div style={{ paddingTop: "1px" }} className="podcast-box-comment">
              <p
                style={{ display: "flex", justifyContent: "center" }}
                className="podcast-box-text"
              >
                <img
                  style={{
                    width: "112px",
                    height: "90px",
                    borderRadius: "5px",
                  }}
                  src={image}
                />
              </p>
            </div>
          </div>
          <div className="bottom">
            <a className="bottom-hashtag">#کتاب-اول</a>
            <a className="bottom-hashtag">#پوستر</a>
          </div>
        </div>
      )}
      {postType === "Audio" && (
        <div className="BellNotification_content-inside">
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="top"
          >
            {type === "لایک" ? (
              <img className="send-img" src={icon} />
            ) : (
              <img className="send-img" src="/imgs/BellNotif/comment.svg" />
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginLeft: "6px" }}
                  src="/imgs/BellNotif/imgProfile.svg"
                />
                <p className="center-title">
                  {type === "لایک" ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "bold",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        {postUser}
                      </p>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        لایکت کرده:
                      </p>
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "bold",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        {postUser}
                      </p>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        کامنت گذاشته:
                      </p>
                    </div>
                  )}
                </p>
              </div>
              <p className="top-time number-font">
                {moment(fullDate).locale("fa").format("YYYY/m/DD")}
              </p>
            </div>
          </div>
          <div className="podcast">
            <div style={{ marginTop: "15px" }}>
              <div className="podcast-text">{comment}</div>
              <div className="test-karshenasi-mob">{comment}</div>
            </div>
            <div style={{ padding: "10px" }} className="podcast-box">
              {/* <img src="/imgs/BellNotif/bi_pause-circle-fill.svg" /> */}
              <div
                onClick={playPause}
                className="podcast-box-icon podcast-in-desc"
              >
                <img
                  src={
                    iconPlayer
                      ? "/imgs/Profile/Play-icon.svg"
                      : "/imgs/Profile/icon-pleyer.svg"
                  }
                  id="songPlayPause"
                />
              </div>
              <div className="podcast-in-mob" id="AudioPlayer">
                <div className="Audio-player-inside">
                  <img
                    onClick={changeVolume}
                    id="volumeMeter"
                    className="Audio-player-inside-volume"
                    src={
                      volumePlayer
                        ? "/imgs/Profile/Volume.svg"
                        : "/imgs/Profile/Volume-res.svg"
                    }
                  />
                  <div
                    className="Audio-player-inside-line"
                    onClick={(e) => setSongPosition(e)}
                  >
                    <div className="progress song" ref={song}>
                      <div className="line" ref={line}></div>
                    </div>
                  </div>
                  <div
                    className="Audio-player-inside-time"
                    onClick={updateTime}
                  >
                    <p className="Audio-player-inside-time-time-text number-font">
                      {timePlayer}
                    </p>
                  </div>
                  <img
                    className="Audio-player-inside-next"
                    src="/imgs/Profile/forward-next.svg"
                    onClick={next}
                  />

                  <div
                    className="Audio-player-inside-player"
                    onClick={playPause}
                  >
                    <img
                      src={
                        iconPlayer
                          ? "/imgs/Profile/Play-icon.svg"
                          : "/imgs/Profile/icon-pleyer.svg"
                      }
                      id="songPlayPause"
                    />
                  </div>
                  <img
                    className="Audio-player-inside-pre"
                    src="/imgs/Profile/forward-pre.svg"
                    onClick={pre}
                  />
                </div>
              </div>
              <div className="podcast-box-right">
                <p className="podcast-box-right-title">{text}</p>
                <div className="podcast-box-right-bottom">
                  <p className="podcast-box-right-bottom-time number-font">
                    {moment(fullDate).locale("fa").format("HH:mm")}
                  </p>
                  <p className="podcast-box-right-bottom-day number-font">
                    {day}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <a className="bottom-hashtag">#کتاب-اول</a>
            <a className="bottom-hashtag">#پوستر</a>
          </div>
          <audio
            onDurationChange={updateTime}
            onTimeUpdate={updateTime}
            src={image}
            hidden
            id="audio"
            ref={refAudio}
          />
        </div>
      )}
      {postType === "" && (
        <div className="BellNotification_content-inside">
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="top"
          >
            {type === "لایک" ? (
              <img className="send-img" src={icon} />
            ) : (
              <img className="send-img" src="/imgs/BellNotif/comment.svg" />
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginLeft: "6px" }}
                  src="/imgs/BellNotif/imgProfile.svg"
                />
                <p className="center-title">
                  {type === "لایک" ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "bold",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        {postUser}
                      </p>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        لایکت کرده:
                      </p>
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "bold",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        {postUser}
                      </p>
                      <p
                        style={{
                          marginLeft: "5px",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          color: "#020D1B",
                        }}
                      >
                        کامنت گذاشته:
                      </p>
                    </div>
                  )}
                </p>
              </div>
              <p className="top-time number-font">
                {moment(fullDate).locale("fa").format("YYYY/m/DD")}
              </p>
            </div>
          </div>
          <div className="podcast">
            <div style={{ marginTop: "15px" }}>
              <div className="podcast-text">{comment}</div>
              <div className="test-karshenasi-mob">{comment}</div>
            </div>
            <div style={{ paddingTop: "1px" }} className="podcast-box-comment">
              <p className="podcast-box-text">{text}</p>
            </div>
          </div>
          <div className="bottom">
            <a className="bottom-hashtag">#کتاب-اول</a>
            <a className="bottom-hashtag">#پوستر</a>
          </div>
        </div>
      )}
    </div>
  );
};
ComponentBellReceive.defaultProps = {};

export default ComponentBellReceive;
